var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3003L0.0847731 11.1817L4.09398 3.57428L4.10245 3.49374L2.33515 0.174012C2.18701 -0.104066 1.77013 -0.0337474 1.72158 0.277553L0 11.3003Z",
    fill: "#FFC24A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39099 6.00482L6.70691 4.65715L5.39059 2.14431C5.26565 1.90644 4.91677 1.90572 4.79314 2.14431L4.08984 3.48546V3.59967L5.39095 6.00482H5.39099Z",
    fill: "#F4BD62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3003L0.0384134 11.2617L0.178011 11.205L5.3082 6.09382L5.37321 5.91688L4.09343 3.47815L0 11.3003Z",
    fill: "#F6820C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55521 13.8779L10.1982 11.2885L8.8723 3.1229C8.83082 2.86742 8.5174 2.76643 8.33452 2.9496L0 11.3003L4.61632 13.8777C4.75981 13.9578 4.9214 13.9999 5.08574 14C5.25008 14 5.41169 13.958 5.55521 13.8779",
    fill: "#FDE068"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1568 11.2669L8.84101 3.16326C8.79988 2.9097 8.53921 2.8048 8.35772 2.9866L0.0517578 11.2845L4.61741 13.8364C4.7598 13.9159 4.92016 13.9576 5.08325 13.9577C5.24633 13.9577 5.40672 13.916 5.54915 13.8366L10.1568 11.2669L10.1568 11.2669Z",
    fill: "#FCCA3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55513 13.8017C5.41161 13.8817 5.25001 13.9237 5.08568 13.9237C4.92135 13.9236 4.75976 13.8816 4.61628 13.8015L0.0371356 11.2611L0 11.3003L4.61628 13.8778C4.75977 13.9579 4.92136 14 5.0857 14C5.25004 14 5.41165 13.958 5.55517 13.878L10.1981 11.2886L10.1867 11.2186L5.55517 13.8017L5.55513 13.8017Z",
    fill: "#EEAB37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/Firebase.34d9e3845b788bc368ea905a0bfa8efe.svg";
export { ForwardRef as ReactComponent };